import { ListarInsightsSaude, ObterInsightSaude } from "@/api/insightsSaude";

const initialState = () => ({
  insights: []
});

export default {
  namespaced: true,
  state: () => initialState(),
  mutations: {
    SET_INSIGHTS(state, insights) {
      state.insights = insights;
    },
    RESET_CONTEXT(state) {
      Object.assign(state, initialState());
    },
    LOGOUT_USER(state) {
      Object.assign(state, initialState());
    }
  },
  actions: {
    async listInsights(context) {
      const resp = await ListarInsightsSaude({
        vinculo: context.rootState.saude?.vinculo
      });
      const insights = resp?.Data || [];
      context.commit("SET_INSIGHTS", insights);
      return insights;
    },
    // O detalhe sempre vai a API: a equipe pode ter editado o resumo depois da listagem.
    async fetchInsight(context, { id }) {
      const resp = await ObterInsightSaude({
        vinculo: context.rootState.saude?.vinculo,
        id
      });
      return resp?.Data || null;
    }
  }
};
